import { isBefore } from 'date-fns'

export const dates = {
  previous: '2025-01-20',
  latest: '2026-03-19',
} as const

type Return = (typeof dates)[keyof typeof dates]

export const getCurrentTosEffectiveDate = (): Return => {
  const nowInUTC = new Date()
  const latestTosEffectiveDate = new Date(dates.latest)

  return isBefore(nowInUTC, latestTosEffectiveDate) ? dates.previous : dates.latest
}
